import { REVIEWS_CATEGORY, REVIEWS_COUNT_LABELS } from '../constants/filters';
import { OrganizationType } from '../constants/organizationType';

export const generateOptions = (enumeration) =>
  Object.entries(enumeration)
    .filter(([_, label]) => label)
    .map(([value, label]) => ({
      label,
      value,
    }));

export const generateReviewsCountOptions = (organizationType: OrganizationType) => {
  const labelsForBanks = { ...REVIEWS_COUNT_LABELS, [REVIEWS_CATEGORY.MORE_THAN_300]: undefined };
  const labelsForOthers = { ...REVIEWS_COUNT_LABELS, [REVIEWS_CATEGORY.MORE_THAN_500]: undefined };

  if (organizationType !== OrganizationType.BANK) return generateOptions(labelsForOthers);

  return generateOptions(labelsForBanks);
};
